import { render, staticRenderFns } from "./btnXS.vue?vue&type=template&id=7180da01&scoped=true&"
import script from "./btnXS.vue?vue&type=script&lang=js&"
export * from "./btnXS.vue?vue&type=script&lang=js&"
import style0 from "./btnXS.vue?vue&type=style&index=0&id=7180da01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180da01",
  null
  
)

export default component.exports